// src/destinations-url.js
// Resolves a visamundi.co destination landing-page URL for a selected country,
// when that country is one of the Visamundi destinations.
import { alpha2 } from './iso.js';
import { DESTINATION_SLUGS } from './destinations.js';

// Per-locale base path for visamundi.co destination pages (the path segment is
// localized too — destinations / reiseziele / destinazioni / destinos).
const LOCALE_PATH = {
  fr: 'https://www.visamundi.co/destinations/',
  en: 'https://www.visamundi.co/en/destinations/',
  de: 'https://www.visamundi.co/de/reiseziele/',
  it: 'https://www.visamundi.co/it/destinazioni/',
  es: 'https://www.visamundi.co/es/destinos/',
};

// Returns the destination URL for an alpha-3 country code, or '' when the country
// is not a Visamundi destination.
export function destinationUrl(alpha3, lang = 'en') {
  const slugs = DESTINATION_SLUGS[alpha2(alpha3)];
  if (!slugs) return '';
  const l = LOCALE_PATH[lang] ? lang : 'en';
  const slug = slugs[l] || slugs.en || slugs.fr;
  return slug ? `${LOCALE_PATH[l]}${slug}/` : '';
}
